<template>
  <div v-resize="setContentHeight">
    <div>
      <v-toolbar dark color="primary" class="px-1">
        <v-toolbar-title>My Bookings</v-toolbar-title>
      </v-toolbar>

      <v-tabs
        v-model="tabs"
        fixed-tabs
        background-color="primary"
        dark
        height="40"
      >
        <v-tab class="subtitle-1 font-weight-bold text-capitalize">Today</v-tab>
        <v-tab class="subtitle-1 font-weight-bold text-capitalize"
          >Upcoming</v-tab
        >
        <v-tab class="subtitle-1 font-weight-bold text-capitalize"
          >Cancelled</v-tab
        >

        <v-divider />
      </v-tabs>
    </div>

    <div v-if="accountInfo" ref="myBookingsScrollable">
      <v-tabs-items v-model="tabs" style="height: 100%" class="scrollable">
        <v-tab-item style="height: 100%">
          <MyBookingList
            :bookings="
              mergedVisitAndSeatBookingsList.filter(
                (x) =>
                  isToday(x.startTime) && x.lastAction !== 'ManualFullCancel'
              )
            "
          />
        </v-tab-item>

        <v-tab-item style="height: 100%">
          <MyBookingList
            :bookings="
              mergedVisitAndSeatBookingsList.filter(
                (x) =>
                  checkDate(x.startTime) > 0 &&
                  x.lastAction !== 'ManualFullCancel'
              )
            "
          />
        </v-tab-item>

        <v-tab-item style="height: 100%">
          <MyBookingList
            :bookings="
              mergedVisitAndSeatBookingsList.filter(
                (x) => x.lastAction === 'ManualFullCancel'
              )
            "
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import MyBookingList from "@/components/MyBookingList";
import validators from "@/helpers/validators";

export default {
  name: "MyBookings",
  components: { MyBookingList },
  props: {
    tabNo: Number,
  },
  data: () => ({
    tabs: 0,
  }),
  computed: {
    mergedVisitAndSeatBookingsList() {
      const mergedList = [
        ...this.accountInfo.visitBookings,
        ...this.accountInfo.bookings,
      ];

      return mergedList.sort(
        (x, y) =>
          x.startTime.localeCompare(y.startTime) ||
          x.endTime.localeCompare(y.endTime)
      );
    },
  },
  methods: {
    setContentHeight() {
      if (this.$refs.myBookingsScrollable) {
        const heights = this.heights();
        const contentHeight =
          heights.screen - heights.toolbar - heights.tabbar - heights.bottombar - heights.noticeBarHeight;

        this.$refs.myBookingsScrollable.style.height = contentHeight + "px";
      }
    },
    isToday(date) {
      return validators.isToday(date, this.time.nowMoment);
    },
    checkDate(date) {
      return validators.checkDate(date, this.time.todayMoment);
    },
  },
  activated() {
    this.$nextTick(() => this.setContentHeight());
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (
        from.name === "BookingDetails" ||
        from.name === "VisitBookingDetails"
      ) {
        vm.tabs = vm.tabNo;
      }
    });
  },
};
</script>